import { render, staticRenderFns } from "./Kaali.vue?vue&type=template&id=4c85c5d2&scoped=true"
import script from "./Kaali.vue?vue&type=script&lang=js"
export * from "./Kaali.vue?vue&type=script&lang=js"
import style0 from "./Kaali.vue?vue&type=style&index=0&id=4c85c5d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c85c5d2",
  null
  
)

export default component.exports